<template>
  <div class="transferRecords">
    <template v-if="isLoading == 2">
        <List
            v-model="loading"
            :finished="finished"
            offset="50"
            :finished-text="$t('bankTransfer.b000011')"
            @load="loadMore">
            <div class="item" v-for="(item, index) in transferRecords" :key="index" :class="{ active: activeId == item.id }" @click="clickItem(item)">
               <div class="module">
                    <div class="top">
                        <div class="left">{{ $t("moneyExchange.m000016") }} {{ item.transfer_no }}</div>
                        <div class="right">
                            <!-- 划转状态：0待处理，1成功 2失败 3已取消 -->
                            <span class="pending" v-if="item.transfer_status == 0">{{$t("moneyExchange.m000020[0]")}}</span>
                            <span class="success" v-else-if="item.transfer_status == 1">{{$t("moneyExchange.m000020[1]")}}</span>
                            <span class="failed" v-else-if="item.transfer_status == 2">{{$t("moneyExchange.m000020[2]")}}</span>
                            <span class="cancelled" v-else>{{$t("moneyExchange.m000020[3]")}}</span>
                        </div>
                    </div>
                    <div class="center">
                        <div class="toAccount">
                            <img class="icon" v-if="item.a_account_type == 1" src="../../../assets/images/app-pages/future.png" >
                            <img class="icon" v-if="item.a_account_type == 2" src="../../../assets/images/app-pages/security.png" >
                            <span class="text" v-if="lang != 'en'">{{ item.a_account_type == 1 ? `${$t('transferInto.accountName[0]')}(${item.a_account})` : `${$t('transferInto.accountName[1]')}(${item.a_account})` }}</span>
                            <span class="text" v-else>{{ item.a_account }}</span>
                        </div>
                        <img class="arrow" src="../../../assets/images/app-pages/Group 4090@3x.png" >
                        <div class="toAccount">
                            <img class="icon" v-if="item.b_account_type == 1" src="../../../assets/images/app-pages/future.png" >
                            <img class="icon" v-if="item.b_account_type == 2" src="../../../assets/images/app-pages/security.png" >
                            <span class="text" v-if="lang != 'en'">{{ item.b_account_type == 1 ? `${$t('transferInto.accountName[0]')}(${item.b_account})` : `${$t('transferInto.accountName[1]')}(${item.b_account})` }}</span>
                            <span class="text" v-else>{{ item.b_account }}</span>
                        </div>
                    </div>
                    <div class="bot">
                        <div class="left">{{ item.transfer_currency }} {{ item.is_all == 1 ? $t('withdrawNew.lang6') : getAmount(item.amount) }}</div>
                        <div class="right" v-if="item.transfer_status == 0">{{ formatDate(item.created_at) }}</div>
                        <div class="right" v-else>{{ formatDate(item.updated_at) }}</div>
                    </div>
               </div>
               <div class="btn" @click.stop="cancelOrder">{{ $t("moneyExchange.m000017") }}</div>
            </div>
        </List>
    </template>
    <!-- 没有数据 -->
    <template v-if="isLoading == 3">
        <div class="empty">
            <img class="emptyIcon" src="../../../assets/images/app-pages/recordEmpty.png" >
            <span class="text">{{ $t('bankTransfer.b000019') }}</span>
        </div>
    </template>
    <!-- 是否确认取消弹窗 -->
    <van-dialog
      :title="$t('fundsTransfer.f000008')"
      :class="bgColor == 'black-theme' ? 'darkOrLight':'defaultDialog'"
      v-model="showConfirm"
      :confirm-button-text="$t('fundsTransfer.f000014')"
      :cancel-button-text="$t('moneyExchange.m000013')"
      show-cancel-button
      :message="$t('moneyExchange.m000014')"
      @confirm="verifyCancel"
    >
    </van-dialog>
    <!-- 取消成功弹窗 -->
    <van-dialog
        :class="bgColor == 'black-theme' ? 'darkOrLight':'defaultDialog'"
        v-model="showSuccess"
        :show-confirm-button="false"
        :showCancelButton="false"
        class="m-open-dialog"
    >
        <div class="dialog-main">
            <div class="dialog-title">
                <img src="@/assets/images/open-account/tip_icon.png" class="img-dia" />
            </div>
            <p class="text">{{ $t('moneyExchange.m000015') }}</p>
            <div class="foot-dia-btn">
                <div class="dia-btn" @click="okay">{{ $t("fundsTransfer.f000009") }}</div>
            </div>
        </div>
    </van-dialog>
  </div>
</template>

<script>
import { List, Dialog } from 'vant'; 
import { localeString } from '@/utils/utils.new';
import { formatDate } from '../tools/tools';

export default {
    name: 'transferRecords',
    components: { 
        List,
        [Dialog.Component.name]: Dialog.Component,
    },
    data() {
        return {
            transferRecords: [],
            loading: false,
            finished: false,
            isLoading: 1,
            activeId: -1,
            showConfirm: false,     // 控制确认弹窗显示
            showSuccess: false,      // 控制成功弹窗显示
            lang: 'zh-CN'
        }
    },
    computed: {
        bgColor() {
            return this.$store.getters["common/bgColor"];
        },
        formatDate() {
            return dateStr => {
                return formatDate(dateStr);
            }
        }
    },
    created() {
        this.init();
        this.lang = localStorage.getItem('localLang') || 'zh-CN';
    },
    methods: {
        init() {
            this.getRouteParams();
            this.getTransferRecords();
        },
        getRouteParams() {
            this.query = { 
                page: 1,  
                page_size: 20,
                account: this.$route.query.account_no,
                account_type: this.$route.query.account_type,
            }; 
        },
        getTransferRecords() {
            this.$apis.getTransferRecords(this.query).then( res => {
                // 空数据
                if ( res.data.length <= 0 ) {
                    this.isLoading = 3;
                    return false;
                }
                // 写入数据
                if ( this.query.page == 1 ) {
                    this.transferRecords = res.data;
                } else {
                    this.transferRecords = [...this.transferRecords, ...res.data];
                }
                this.loading = false;
                this.isLoading = 2;
                // 是否到底
                if ( res.total == this.transferRecords.length ) {
                    this.finished = true;
                }
            })
        },
        clickItem(item) {
            if ( item.transfer_status != 0 ) return false;
            this.activeId = (this.activeId == item.id) ? -1 : item.id;
        },
        cancelOrder() {
            this.showConfirm = true;
        },
        verifyCancel() {
            this.$apis.revokeTransferLog({ transfer_status:3, id: this.activeId }).then( res => {
                this.query.page = 1;
                this.loading = true;
                this.finished = false;
                this.getTransferRecords();
                this.activeId = -1;
                this.showSuccess = true;
            })
        },
        getAmount(num) {
            return localeString(num)
        },
        okay() {
            this.showSuccess = false;
        },
        loadMore() {
            this.query.page += 1;
            this.getTransferRecords();
        }
    }
}
</script>

<style lang="less" scoped>
@import '../styles/styles.less';
@import './styles.less';
</style>